<template>
  <div class="app-promo-footer-desktop" v-if="!dismissed">
    <button class="app-promo-footer__close" @click="dismissed = true" aria-label="Cerrar">×</button>

    <div class="app-promo-footer__logo">
      <img src="/favicon/apple-icon-57x57.png" alt="HelloBB" />
    </div>

    <div class="app-promo-footer__content">
      <div class="app-promo-footer__title">{{ $t("apppromo.title") }}</div>
      <div class="app-promo-footer__text">
        {{ $t("apppromo.subtitle") }}
      </div>
    </div>

    <router-link to="/signup?utm_source=guest-list-desktop" class="app-promo-footer__cta">{{ $t("home2.cta") }}</router-link>
  </div>
</template>

<script>
export default {
  name: "AppPromoFooterDesktop",
  data() {
    return {
      dismissed: false,
    };
  },
};
</script>

<style scoped>
.app-promo-footer-desktop {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #1e0028;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 24px;
  gap: 16px;
  z-index: 1000;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.1);
}

.app-promo-footer__close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
  margin-right: 8px;
  flex-shrink: 0;
}

.app-promo-footer__logo img {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: white;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.app-promo-footer__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.app-promo-footer__title {
  font-weight: 600;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-promo-footer__text {
  font-size: 14px;
  color: white;
}

.app-promo-footer__cta {
  background: #ffc944;
  color: #1e0028;
  font-weight: bold;
  padding: 10px 16px;
  border-radius: 50px;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
}
@media (max-width: 768px) {
  .app-promo-footer-desktop {
    display: none;
  }
}
</style>
